import { Theme } from "@emotion/react";
import styled from "@emotion/styled";
import { Tag } from "./Tag";

const reviewTagCSS = (theme: Theme) =>
  ({
    alignItems: "center",
    background: theme.colors.bgLight,
    border: `1px solid ${theme.colors.fg}`,
    borderRadius: theme.borderRadius.rounded,
    display: "inline-flex",
    fontSize: theme.fontSizes.xxs,
    padding: "0 1em 0 0",
  } as const);

const variants = {
  founder: "yellow",
  community: "pink",
  roadmap: "green",
  art: "purple",
  default: "black",
};

interface ReviewTagProps {
  count?: number;
  variant: keyof typeof variants;
}

const ReviewTag = styled(Tag)<ReviewTagProps>(({ count, variant, theme }) => ({
  ...reviewTagCSS(theme),
  "&:before": {
    alignItems: "center",
    background: theme.colors[variants[variant]],
    borderRadius: theme.borderRadius.round,
    content: count ? `"${count}"` : "''",
    display: "inline-flex",
    fontSize: theme.fontSizes.xxs,
    height: "1rem",
    justifyContent: "center",
    margin: "0.3em",
    marginRight: "0.5rem",
    minWidth: "1rem",
  },
}));

export { ReviewTag, reviewTagCSS };
